export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkWork: "nav-link-work",
  linkProcess: "nav-link-process",
  linkContact: "nav-link-contact",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  video: "hero-video",
};

export const SERVICES = {
  section: "services-section",
  card: (slug) => `service-card-${slug}`,
};

export const TECH = {
  section: "tech-section",
};

export const PROCESS = {
  section: "process-section",
  step: (n) => `process-step-${n}`,
};

export const WORK = {
  section: "work-section",
  card: (slug) => `work-card-${slug}`,
};

export const TESTI = {
  section: "testimonials-section",
};

export const CTA = {
  section: "cta-section",
  emailLink: "cta-email-link",
};

export const FOOTER = {
  section: "footer-section",
  emailLink: "footer-email-link",
};
